<style lang="less">
    .delLayer-dialog {
        width: 386px;
        .delLayer-content {
            padding: 20px;
        }
        .delLayer-select {
            margin-top: 20px;
        }
        .dialog-btnbox-normal {
            margin-top: 8px;
        }
    }
</style>

<template>
    <Dialog class="delLayer-dialog" :title="VersionTipType == 'del' ? $t('title') : $t('titleOpen')" :mask="true" @close="closeThis">
        <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
            <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
            <div class="" @click="closeThis()">{{ $t("cancel") }}</div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Watch, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class DelLayer extends Vue {
        get VersionTipType() {
            return this.$store.state.version.VersionTipType;
        }

        closeThis() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        confirm() {
            if (this.VersionTipType == "del") {
                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: true,
                });
                this.closeThis();
                this.$store
                    .dispatch("delVersion")
                    .then((res) => {
                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                    })
                    .catch((err) => {
                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                    });
            } else if (this.VersionTipType == "open") {
                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: true,
                });
                this.closeThis();
                let obj = this.$store.state.ui.fileInfo;
                this.$store
                    .dispatch("backVersion", { obj })
                    .then((res) => {
                        this.$store.commit("setStatus", {
                            type: "showLibrary",
                            data: true,
                        });
                        this.$store.commit("setStatus", {
                            type: "ignorePwd",
                            data: true,
                        });
                        window["_view"].openFromFile(res.data);
                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                    })
                    .catch((err) => {
                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                    });
            }
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "确认删除该版本吗？",
    "titleOpen": "确认要覆盖当前文件吗",
    "confirm": "确认",
    "cancel": "取消"
  },
  "en": {
    "title": "Are you confirmed to delete this version？",
    "titleOpen": "Are you confirmed to replace this file?",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "jp": {
    "title": "このバージョンを削除してもよろしいですか？",
    "titleOpen": "現在のファイルを上書きしてもよろしいですか",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "de": {
    "title": "Möchten Sie diese Version löschen?",
    "titleOpen": "Möchten Sie diese Datei ersetzen?",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "fr": {
    "title": "Confirmé pour supprimer cette version？",
    "titleOpen": "Confirmé pour remplacer ce fichier?",
    "confirm": "OK",
    "cancel": "Annuler"
  },
  "es": {
    "title": "¿Se confirma que se ha eliminado este version？",
    "titleOpen": "¿Está confirmado que sustituirá este archivo?",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Confirmar para elmininar esta versão？",
    "titleOpen": "Confirmar para substituir este ficheiro?",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Confermi di voler eliminare questa versione?",
    "titleOpen": "Confermi di voler sostituire questo file?",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "確認刪除該版本嗎？",
    "titleOpen": "確認要覆蓋當前檔案嗎",
    "confirm": "確認",
    "cancel": "取消"
  },
  "kr": {
    "title": "이 버전을 삭제하시겠습니까?",
    "titleOpen": "현재 파일을 덮어쓰시겠습니까?",
    "confirm": "확인",
    "cancel": "취소"
  }
}
</i18n>
